// extracted by mini-css-extract-plugin
export default {"sclBox":"CustomTableRows_sclBox__ynF2H"};